import { render, staticRenderFns } from "./TenantMenu.vue?vue&type=template&id=6bed7202&scoped=true"
import script from "./TenantMenu.vue?vue&type=script&lang=js"
export * from "./TenantMenu.vue?vue&type=script&lang=js"
import style0 from "./TenantMenu.vue?vue&type=style&index=0&id=6bed7202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed7202",
  null
  
)

export default component.exports